// React and related imports
import React from 'react';

// Flowbite UI components and icons
import { Dropdown, Spinner } from 'flowbite-react';
import { HiOutlineLogout, HiOutlineMail } from 'react-icons/hi';
import male from '../../assets/images/Male.png';

// i18n for translations
import { useTranslation } from 'react-i18next';

interface UserDropdownProps {
  username: string;
  email: string;
  onSignOut: () => void;
  signingOut?: boolean;
}

export const UserDropdown: React.FC<UserDropdownProps> = ({
  username,
  email,
  onSignOut,
  signingOut = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dropdown
      arrowIcon={false}
      inline
      label={<img src={male} className="w-9" alt="user" />}
    >
      <Dropdown.Header>
        <span className="mb-2 block text-sm font-bold">{username}</span>

        <span className="flex items-center truncate text-sm font-medium">
          <HiOutlineMail className="me-2 align-middle text-lg" />
          {email}
        </span>
      </Dropdown.Header>
      <Dropdown.Item
        disabled={true}
        className="cursor-not-allowed opacity-50 hover:bg-white dark:hover:bg-gray-700 dark:hover:text-gray-200"
      >
        {t('header.userDropdown.settings')}
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item
        onClick={onSignOut}
        disabled={signingOut}
        aria-busy={signingOut}
      >
        {signingOut ? (
          <Spinner size="sm" className="me-2" />
        ) : (
          <HiOutlineLogout className="me-2 align-middle text-lg" />
        )}
        {t('header.userDropdown.signout')}
      </Dropdown.Item>
    </Dropdown>
  );
};
